import pokusService from './pokusUtils';
import { MMT_HLD_VAR, MMT_SESSION_ID } from '../constants/mmtGlobal';

const setGlobalVariable = async (showDefaultValue = false) => {
  const MMT_HLD = ssr.isOnClient ? window.MMT_HLD : ssr.MMT_HLD;
  if (ssr.isOnClient && !showDefaultValue) {
    if (sessionStorage.getItem(MMT_SESSION_ID)) {
      window.MMT_HLD = JSON.parse(sessionStorage.getItem(MMT_SESSION_ID));
    } else {
      const setPokusData = await pokusService();
      MMT_HLD_VAR.forEach(object => {
        MMT_HLD[object.mmtName] = setPokusData(object.pokusName, object.defaultValue);
      });
      sessionStorage.setItem(MMT_SESSION_ID, JSON.stringify(MMT_HLD));
    }
  } else {
    MMT_HLD_VAR.forEach(object => {
      MMT_HLD[object.mmtName] = object.defaultValue;
    });
  }
};

export default setGlobalVariable;
